"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var StoreApple = function (_a) {
    var fill = _a.fill, props = __rest(_a, ["fill"]);
    return (React.createElement("svg", __assign({ fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.21 4.584c.426-1.34 1.478-2.302 2.986-2.603L15.804.019c-2.59.518-4.286 2.404-4.703 4.8-.2-.068-.422-.153-.678-.252l-.007-.002C9.786 4.32 8.958 4 8 4c-2.08 0-3.628.911-4.623 2.29C2.409 7.63 2 9.352 2 11c0 2.182.675 4.594 1.681 6.472.505.942 1.116 1.795 1.811 2.425C6.18 20.521 7.035 21 8 21c1.181 0 2.067-.3 2.746-.572.137-.054.253-.102.357-.146.172-.071.313-.13.464-.183.22-.077.347-.099.433-.099.392 0 .674.117 1.218.344l.151.063c.638.264 1.443.559 2.631.559 1.725 0 2.871-1.05 3.596-2.2.714-1.133 1.12-2.506 1.374-3.523a1 1 0 0 0-.727-1.213C18.805 13.67 18 12.174 18 11c0-.513.186-1.198.584-1.802.392-.592.948-1.05 1.659-1.228a1 1 0 0 0 .517-1.62C19.707 5.118 17.798 4 16 4c-.928 0-1.94.301-2.691.551l-.099.033zM4 11c0-1.352.34-2.63.998-3.54C5.628 6.59 6.58 6 8 6c.539 0 1.041.177 1.701.433l.102.04C10.392 6.7 11.16 7 12 7c.196 0 .384-.044.505-.075.138-.036.289-.083.436-.133.138-.045.288-.098.44-.151l.038-.013c.168-.059.342-.12.522-.18C14.691 6.199 15.428 6 16 6c.687 0 1.498.303 2.195.754a5.114 5.114 0 0 0-1.28 1.342c-.6.91-.915 1.976-.915 2.904 0 1.58.895 3.667 2.795 4.616-.222.733-.507 1.475-.891 2.084-.525.833-1.13 1.266-1.904 1.266-.812 0-1.338-.188-1.865-.407l-.168-.07c-.5-.213-1.15-.489-1.967-.489a3.29 3.29 0 0 0-1.098.213c-.2.07-.427.165-.634.25-.094.039-.183.076-.264.108C9.433 18.8 8.819 19 8 19c-.285 0-.68-.146-1.164-.585-.477-.432-.96-1.08-1.392-1.887C4.575 14.907 4 12.818 4 11z", fill: fill || 'currentColor' })));
};
exports.default = StoreApple;
